<template>
  <div>
    <div class="input-group select2-plugin">
      <select class="form-control select2" style="width:100%;" ref="slEmpleado">
        <option value="">Seleccione un empleado</option>
        <option v-for="oUser in usuariosProcesado" :value="oUser._id" :key="oUser._id">{{oUser.displayName}} <span class="label label-danger" v-if="oUser.tienePedidosFecha">tiene pedidos</span></option>
      </select>
      <span class="input-group-btn">
        <button class="btn btn-fill" type="button" @click.prevent="selectEmpleado">OK</button>
      </span>
    </div>
    <span class="label label-danger" :class="{hide: !mostrarMensaje}">Debe seleccionar un empleado</span>
  </div>
</template>
<script>
  import './../../assets/css/select2.css'
  import './../../assets/css/select2_status.css'
  import $ from 'jquery'
  import 'select2'
  import moment from 'moment'

  export default {
    computed: {
      usuariosProcesado () {
        console.log('usuariosprocesado')
        const me = this
        me.users.forEach((user) => {
          let tienePedidoFecha = user.pedidos.find((pedido) => {
            return moment(pedido.fechaEntrega).format('DDMMYYYY') === moment(new Date(me.fecha)).format('DDMMYYYY')
          })
          user.tienePedidoFecha = tienePedidoFecha
        })
      }
    },
    props: ['users', 'fecha', 'plato', 'admin', 'combo'],
    mounted () {
      const me = this
      console.log('mounted combo empleados')
      const $select = $('.select2')
      $select.select2({
        placeholder: 'Seleccionar empleado'
      })
      .on('change', (e) => {
        me.mostrarMensaje = false
      })

      $select.val(me.admin._id)
      $select.trigger('change')
    },
    data () {
      return {
        mostrarMensaje: false
      }
    },
    methods: {
      selectEmpleado () {
        var value = this.$refs.slEmpleado.value
        if (value) {
          this.$emit('select-empleado', {
            idEmpleado: value,
            fecha: this.fecha,
            plato: this.plato
          })
        } else {
          this.mostrarMensaje = true
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EmpleadosEmpresa.vue?6b41f6ca